import {Text, TouchableOpacity, View} from "react-native";
import styles from "./styles";
import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import {Placeholder, PlaceholderLine, Shine} from "rn-placeholder";

export default function HomeCategories(props){
    let onFilterPress = (cat_id) => {
        props.filterFunction(cat_id)
    }
    let onFilterClear = () => {
        props.clearFunction()
    }
    if(props.catData){
        if(props.loading){
            return(
                <Placeholder Animation={Shine}>
                    <View>
                        <PlaceholderLine />
                    </View>
                </Placeholder>
            )
        } else {
            return (
                <View style={{flexDirection:"row"}}>
                    <View style={styles.categoryButton}>
                        <TouchableOpacity  onPress={() => onFilterClear()}>
                            <View style={[styles.iconFull, {backgroundColor:'#ffcd11'}]}>
                                <FontAwesome5
                                    name="th-large"
                                    size={18}
                                    color="white"
                                    type="FontAwesome5"
                                    solid
                                />
                            </View>
                            <Text style={styles.categoryText}>All</Text>
                        </TouchableOpacity>
                    </View>
                    {props.catData.map((category,index) => {
                        return(
                            <View key={category.id} style={styles.categoryButton}>
                                <TouchableOpacity  onPress={() => onFilterPress(category.id)} style={{alignItems:'center'}}>
                                    <View style={[styles.iconFull, {backgroundColor:category.color}]}>
                                        <FontAwesome5
                                            name={category.icon}
                                            size={18}
                                            color="white"
                                            type="FontAwesome5"
                                            solid
                                        />
                                    </View>
                                    <Text style={styles.categoryText}>{category.name}</Text>
                                </TouchableOpacity>
                            </View>
                        )})}
                </View>
            )
        }

    } else {
        return(
            <></>
        )
    }
}